import type { LDInspectionFlagDetailsChangedHandler } from 'launchdarkly-react-client-sdk'
import { isEmpty } from 'lodash'
import { logError } from 'lib/tracking/datadog'
import { flags } from '../../FeatureFlagsProvider.consts'

export const loggedErrorsMessages: string[] = []

export const logNonExistentFlags: LDInspectionFlagDetailsChangedHandler['method'] = (evaluationResult) => {
  if (isEmpty(evaluationResult)) {
    return
  }

  const missing = Object.keys(flags).filter((key) => !(key in evaluationResult))

  if (!missing.length) {
    return
  }

  const errorMessage = `Feature flag${missing.length > 1 ? 's' : ''} <${missing.join(', ')}> not found in LaunchDarkly`

  if (loggedErrorsMessages.includes(errorMessage)) {
    return
  }

  logError(new Error(errorMessage), { flags, evaluationResult })
  loggedErrorsMessages.push(errorMessage)

  if (process.env.NODE_ENV === 'development') {
    console.error(errorMessage)
  }
}
